import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';

export const AppointmentWrapper = createWrapper('Appointment', () => ({}));
export type WrappedAppointment = ReturnType<typeof AppointmentWrapper>;